import React from "react";
import ClickToCopyWrapper from "./ClickToCopyWrapper";

class CopyTimeWrapper extends React.PureComponent {
  render() {
    const { localValue, tzValue, children, keepRefresh } = this.props;

    if (localValue === null || tzValue === null) {
      return "--";
    }

    const copyFormat = "YYYY-MM-DD HH:mm";
    const tzText = `${tzValue.format(copyFormat)} NWTZ`;
    const localText = `${localValue.format(copyFormat)} TPE`;
    const copyText = tzText === localText ? tzText : `${tzText} (${localText})`;

    return (
      <ClickToCopyWrapper
        copyText={copyText}
        buttonText={children || copyText}
        iconType=""
        keepRefresh={keepRefresh}
      />
    );
  }
}

export default CopyTimeWrapper;
